import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["heroPrice"]
  static values = {
    url: String,
    monthlyHero: String,
    yearlyHero: String,
  }

  connect() {
    this.persistedFrequency = this.element.querySelector('input[type="radio"]:checked')?.value
  }

  update(event) {
    const target = event.target
    if (target.type !== "radio" || !target.checked) return

    this.updateHero(target.value)
    this.persistFrequency(target.value)
  }

  updateHero(paymentFrequency) {
    if (!this.hasHeroPriceTarget) return

    const text = paymentFrequency === "month" ? this.monthlyHeroValue : this.yearlyHeroValue
    if (text) this.heroPriceTarget.textContent = text
  }

  async persistFrequency(paymentFrequency) {
    if (!paymentFrequency) return

    this.setLoading(true)

    try {
      const body = new FormData()
      body.append("payment_frequency", paymentFrequency)

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.csrfToken,
        },
        body,
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const turboStream = await response.text()
      Turbo.renderStreamMessage(turboStream)
      this.persistedFrequency = paymentFrequency
    } catch (error) {
      console.error("Payment frequency update failed:", error)
      this.restore(this.persistedFrequency)
    } finally {
      this.setLoading(false)
    }
  }

  restore(paymentFrequency) {
    if (!paymentFrequency) return

    const input = this.element.querySelector(`input[type="radio"][value="${paymentFrequency}"]`)
    if (input) input.checked = true
    this.updateHero(paymentFrequency)
  }

  setLoading(loading) {
    this.element.classList.toggle("opacity-50", loading)
    this.element.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.disabled = loading
    })
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
